(function ($) {
  'use strict';

  /**
   * Alert Bar Controls
   * - Depends on js-cookie lib
   */

  var $alert_bar = $('.js-alert-bar');
  var $alert_close_button = $('.js-toggle-alert');
  var is_hidden_cookie_name = $alert_bar.data( 'hide-cookie-name' );
  var is_hidden_cookie_exp = $alert_bar.data( 'hide-cookie-exp' );
  var is_alert_hidden = Cookies.get( is_hidden_cookie_name );

  // If cookie is ommitted, or _not_ true, disaply alert bar
  if ( is_alert_hidden !== 'true' ) {
    $alert_bar.addClass( 'is-enabled' );
  }

  // Close Alert Bar
  $alert_close_button.on('click', function () {
    $alert_bar.css( 'display', 'none' );
    $alert_bar.removeClass( 'is-enabled' );

    if ( is_hidden_cookie_name && is_hidden_cookie_exp ) {
      Cookies.set(is_hidden_cookie_name, 'true', {
        expires: is_hidden_cookie_exp,
      });
    }
  });

})(jQuery);
